"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.play = exports.oval = exports.videoContainer = void 0;

var react_1 = require("@emotion/react");

exports.videoContainer = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  left: 50%;\n  top: 50%;\n  width: 64px;\n  height: 64px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  transform: translate(-50%, -50%);\n"])));
exports.oval = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: var(--gray-900);\n  opacity: 0.8;\n  cursor: pointer;\n"])));
exports.play = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  left: 0;\n  top: 0;\n  width: 24px;\n  height: 24px;\n  min-width: 100%;\n  transform: translate(0, 0);\n  box-shadow: none !important;\n  cursor: pointer;\n"])));